import { jsx } from 'react/jsx-runtime';
import { createElement } from 'react';
import { textNodeToJsxPrinter, htmlNodeToJsxPrinter, generateJsxKey, convertHtmlAttributesToReactProps, linkAttrs, coreAttrs } from '@utils/ast';

const subPrinters = {
  html: htmlNodeToJsxPrinter,
  text: textNodeToJsxPrinter
};
const linkNodeToJsxPrinter = (node, context) => {
  const children = node.children !== void 0 ? context.printChildren(node.children, subPrinters) : void 0;
  if (node.href === void 0) {
    return /* @__PURE__ */ jsx("span", { "data-anchor": "invalid href", children });
  }
  return /* @__PURE__ */ createElement(
    "a",
    {
      ...convertHtmlAttributesToReactProps("a", node.attributes ?? {}, {
        ...coreAttrs,
        ...linkAttrs
      }),
      key: generateJsxKey(context),
      href: node.href,
      target: node.meta.target
    },
    children
  );
};

export { linkNodeToJsxPrinter };
//# sourceMappingURL=common.links.js.map
